import React, {useRef, useEffect, useContext, Fragment} from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Media from 'react-media';
import {microphonesMutedMessage} from '../../../../configs/messages';
import {ThemeContext} from '../../../common';

export default function QuestionVideo(props) {
  const {url, onPause, onPlay, onVideoEnded, autoPlay, isVideoPlaying, isInterstitial} = props;
  const videoClasses = classNames(
    'video__container',
    {
      video__container_notification: isVideoPlaying,
      video__interstitial: isInterstitial,
    }
  );
  const {primaryColor} = useContext(ThemeContext);
  const videoRef = useRef(null);

  useEffect(() => () => {
    const video = videoRef.current;
    video.currentTime = 0;
    video.pause();
    video.src = ' ';
    video.play().catch(e => e);
  }, []);

  const fullscreenHandler = () => {
    if (!document.fullscreenElement) {
      videoRef.current.pause();
    }
  };

  const onVideoClick = () => {
    if (videoRef.current) {
      if (videoRef.current.requestFullscreen) {
        videoRef.current.requestFullscreen();
      }
      setTimeout(() => videoRef.current.play(), 1000);
    }
  };

  if (window.innerWidth < 700) {
    useEffect(() => {
      videoRef.current.addEventListener('fullscreenchange', fullscreenHandler);

      return () => videoRef.current.removeEventListener('fullscreenchange', fullscreenHandler);
    }, []);
  }

  const handlePause = (e) => {
    if (!isInterstitial) {
      onPause(e);
      if (videoRef.current.webkitExitFullscreen) {
        videoRef.current.webkitExitFullscreen();
      }
    }
  };

  return (
    <div className={videoClasses}>
      <Media queries={{phone: {maxWidth: 700}}}>
        {
          matches =>
            (
              matches.phone ? (
                <Fragment>
                  {
                    !isInterstitial && (
                      <div onClick={onVideoClick}>
                        <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <circle cx="24" cy="24" r="24" fill={primaryColor} className="video-circle"/>
                          <g clipPath="url(#clip0)">
                            <path d="M33.9464 22.5852L18.2321 13.295C16.9554 12.5406 15 13.2727 15 15.1388V33.7147C15 35.3888 16.817 36.3977 18.2321 35.5584L33.9464 26.2727C35.3482 25.4468 35.3527 23.4111 33.9464 22.5852Z" fill="white"/>
                          </g>
                          <defs>
                            <clipPath id="clip0">
                              <rect x="15" y="13" width="20" height="22.8571" fill="white"/>
                            </clipPath>
                          </defs>
                        </svg>
                      </div>
                    )
                  }
                  <video
                    className={`question__video playing_${isVideoPlaying}`}
                    src={url}
                    controls
                    autoPlay={isInterstitial}
                    muted={isInterstitial}
                    playsInline={isInterstitial}
                    onEnded={onVideoEnded}
                    onPause={handlePause}
                    onPlay={onPlay}
                    ref={videoRef}
                    id="question-video"
                  >
                    <track kind="captions"/>
                  </video>
                </Fragment>
              ) : (
                <Fragment>
                  <video
                    className="question__video"
                    src={url}
                    controls
                    autoPlay={autoPlay}
                    onEnded={onVideoEnded}
                    onPause={onPause}
                    onPlay={onPlay}
                    ref={videoRef}
                  >
                    <track kind="captions"/>
                  </video>
                  <div className="mute-notice">
                    {isVideoPlaying && microphonesMutedMessage}
                  </div>
                </Fragment>
              )
            )
        }
      </Media>
    </div>
  );
}

QuestionVideo.propTypes = {
  url: PropTypes.string.isRequired,
  onVideoEnded: PropTypes.func,
  onPause: PropTypes.func.isRequired,
  onPlay: PropTypes.func.isRequired,
  autoPlay: PropTypes.bool,
  isVideoPlaying: PropTypes.bool.isRequired,
  isInterstitial: PropTypes.bool.isRequired,
};

QuestionVideo.defaultProps = {
  onVideoEnded: () => {},
  autoPlay: false,
  isInterstitial: false,
};
